import { RootState } from 'store/rootTypes';

export const SenderDetailsSelector = (state: RootState) => state.SenderDetails;
